import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Bot, ListChecks, Sparkles, Network, KeyRound, BarChart3,
  ShieldCheck, Settings as SettingsIcon, CreditCard, PlusCircle,
} from 'lucide-react';
import {
  CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator, CommandShortcut,
} from '@/components/ui/command';
import { useUIStore } from '@/stores/ui';

const NAV_COMMANDS = [
  { key: 'dashboard', label: 'Go to Dashboard', icon: LayoutDashboard, path: '/dashboard', shortcut: '⌘1' },
  { key: 'agents', label: 'Go to Agents', icon: Bot, path: '/agents', shortcut: '⌘2' },
  { key: 'tasks', label: 'Go to Tasks', icon: ListChecks, path: '/tasks', shortcut: '⌘3' },
  { key: 'templates', label: 'Go to Templates', icon: Sparkles, path: '/templates' },
  { key: 'proxies', label: 'Go to Proxies', icon: Network, path: '/proxies' },
  { key: 'credentials', label: 'Go to Credentials', icon: ShieldCheck, path: '/credentials' },
  { key: 'analytics', label: 'Go to Analytics', icon: BarChart3, path: '/analytics' },
  { key: 'api-keys', label: 'Go to API Keys', icon: KeyRound, path: '/api-keys' },
  { key: 'billing', label: 'Go to Billing', icon: CreditCard, path: '/billing' },
  { key: 'settings', label: 'Go to Settings', icon: SettingsIcon, path: '/settings' },
];

export function CommandPalette() {
  const { commandOpen, setCommandOpen } = useUIStore();
  const nav = useNavigate();

  const go = (p) => { setCommandOpen(false); setTimeout(() => nav(p), 20); };

  return (
    <CommandDialog open={commandOpen} onOpenChange={setCommandOpen} data-testid="command-palette-dialog">
      <CommandInput placeholder="Search pages, actions, agents…" data-testid="command-palette-input" />
      <CommandList>
        <CommandEmpty>No results.</CommandEmpty>
        <CommandGroup heading="Navigate">
          {NAV_COMMANDS.map((c) => (
            <CommandItem key={c.key} onSelect={() => go(c.path)} data-testid={`command-palette-item-${c.key}`}>
              <c.icon className="mr-2 h-4 w-4" />
              <span>{c.label}</span>
              {c.shortcut && <CommandShortcut>{c.shortcut}</CommandShortcut>}
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandSeparator />
        <CommandGroup heading="Actions">
          <CommandItem onSelect={() => go('/agents?new=1')} data-testid="command-palette-item-new-agent">
            <PlusCircle className="mr-2 h-4 w-4" />
            Create new agent
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
